module.exports = __webpack_public_path__ + "static/media/Gilmer-Regular.4cf193e6.otf";